
<template>
<markdown-render v-if="guide" :source="guide"></markdown-render>
</template>

<script>
import { mapState } from 'vuex'
import MarkdownRender from '../../MarkdownRender'

export default {
  components:{
    "markdown-render": MarkdownRender
  },

  computed: {
    ...mapState(
      {
          http: state => state.metadata.backendApi.http[state.metadata.env]
      }
    )
  },
  data(){
    return {
      guide: null
    }
  },

  mounted(){
    this.guide = guide;
  }
  
}



const guide = "                                                                                     \n\
# Getting started for FP-ATR-LORA1 and LoRa tracker                                                 \n\
Please follow instructions from [here](https://www.st.com/en/embedded-software/fp-atr-lora1.html) in order to configure properly your device \n\
*Note*: first two steps are optional if default ST device profile is used (*Setup TTN account* and *Setup asset-tracking dashboard*)               \n\
## Setup TTN account                                                                                \n\
1. Create and login user TTN account from [here](https://eu1.cloud.thethings.network/oauth/login)   \n\
2. Create a new api-key from [here](https://eu1.cloud.thethings.network/console/user/api-keys) and take note of the secret value                                             \n\
## Setup asset-tracking dashboard                                                                   \n\
1.  Create a new api-key from **settings** view                                                     \n\
2.  To simplify the device provisioning, create a LoRa device profile from **settings** view        \n\
## Configure device                                                                                 \n\
1. Connect device to local PC via USB and open serial terminal (e.g. TeraTerm)  \n\
2. Take note of device EUI by sending `?devicejoinparam` command                                 \n\
3. Configure device with following commands by using the device profile parameters                  \n\
```json\n\
\n\
!joineui-xxxxxxxxxxxxxxx                    // replace x characthers with join eui value\n\
!ntwkkey-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx     // replace x characthers with network key value\n\
!appkey-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx      // replace x characthers with application key valu\n\
!sysreset\n\
```\n\
*Note*: network key and application key must be equal\n\
## Provision device on asset-tracking dashboard                                                     \n\
From **devices** view regiester a new *LoRa tracker* device by providing:                           \n\
- Human-friendly label                                                                              \n\
- Device ID (got previously)                                                                        \n\
- Device EUI (got previously)                                                                       \n\
- Device profile (use the default profile provided or that one previously created)                  \n\
- Optional parameters which depend by your setup                                                    \n\
"
</script>
